import styles from '../ProfileDeatailForInternalExternal/InviteTalentModal/WhatsAppPreviewTemplate.module.css'

const SkillGigsAvatar = () => (
  <svg className={styles.waAvatar} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#FC1254" />
    <text x="20" y="25" textAnchor="middle" fill="white" fontSize="13" fontWeight="700">SG</text>
  </svg>
)

const TEMPLATE_CONFIG = {
  'Template 1': {
    intro: (name, title) =>
      `Hi ${name || 'Candidate First Name'} 👋\nYour invitation for ${title || 'Job Title'} is still waiting.`,
  },
  'Template 2': {
    intro: (name, title) =>
      `Hi ${name || 'Candidate First Name'} 👋\nThe hiring team is still interested in your profile.`,
  },
  'Template 3': {
    intro: (name, title) =>
      `Hi ${name || 'Candidate First Name'} 👋\nThis opportunity may close soon.`,
  },
}

const ReminderWhatsAppPreviewTemplate = ({
  talentFirstName,
  jobTitle,
  jobDetails = [],
  message,
  companyName,
  selectedTemplate = 'Template 1',
}) => {
  const config = TEMPLATE_CONFIG[selectedTemplate] || TEMPLATE_CONFIG['Template 1']
  const intro = config.intro(talentFirstName, jobTitle)

  const jobDetailsString = jobDetails.length
    ? jobDetails.map((d) => `${d.label}: ${d.value}`).join(', ')
    : null

  return (
    <div className={styles.container}>
      {/* Status Bar */}
      <div className={styles.statusBar}>
        <span className={styles.statusTime}>9:41</span>
        <div className={styles.statusIcons}>
          <svg viewBox="0 0 20 14" fill="#000" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="8" width="3" height="6" rx="0.8" />
            <rect x="4.5" y="5.5" width="3" height="8.5" rx="0.8" />
            <rect x="9" y="3" width="3" height="11" rx="0.8" />
            <rect x="13.5" y="0.5" width="3" height="13.5" rx="0.8" />
          </svg>
          <svg viewBox="0 0 20 14" fill="#000" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 11.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
            <path d="M5.5 7.5C7 6 8.4 5.2 10 5.2s3 .8 4.5 2.3L16 6.2C14.1 4.3 12.2 3.3 10 3.3S5.9 4.3 4 6.2l1.5 1.3z" />
            <path d="M1.5 3.8C4 1.4 6.8 0 10 0s6 1.4 8.5 3.8L20 2.3C17 .8 13.7 0 10 0S3 .8 0 2.3l1.5 1.5z" opacity=".4" />
          </svg>
          <svg viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="1.5" width="23" height="11" rx="2.5" stroke="#000" strokeWidth="1.2" />
            <rect x="2" y="3" width="19" height="8" rx="1.5" fill="#000" />
            <path d="M25 5v4a2 2 0 0 0 0-4z" fill="#000" />
          </svg>
        </div>
      </div>

      {/* WA Header */}
      <div className={styles.waHeader}>
        <span className={styles.waBack}>
          <svg width="10" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.82129 0.5C7.90691 0.500059 7.98026 0.526325 8.0625 0.608398C8.1448 0.694341 8.1709 0.771445 8.1709 0.857422C8.17081 0.944261 8.14426 1.01826 8.0625 1.10059L1.70117 7.46191H15.1113C15.2328 7.46193 15.3079 7.49726 15.3721 7.56055C15.4342 7.6219 15.4687 7.69362 15.4688 7.81348C15.4688 7.93333 15.4342 8.00505 15.3721 8.06641C15.3079 8.12969 15.2328 8.16502 15.1113 8.16504H1.70117L8.05664 14.5205C8.1389 14.602 8.16719 14.6788 8.16797 14.7705C8.16849 14.838 8.15383 14.8964 8.1123 14.9561L8.06055 15.0176C7.9806 15.0985 7.90742 15.1248 7.81836 15.124C7.72391 15.1231 7.6456 15.0931 7.5625 15.0107L0.614258 8.0625C0.561096 8.00833 0.5354 7.9662 0.523438 7.9375C0.50833 7.90019 0.5 7.8601 0.5 7.8125C0.50003 7.76491 0.508641 7.72576 0.523438 7.69043C0.535302 7.66099 0.560769 7.61862 0.614258 7.56445L7.56445 0.614258C7.65485 0.527034 7.73453 0.5 7.82129 0.5Z" fill="#606F7E" stroke="#606F7E" strokeWidth="0.3" />
          </svg>
        </span>
        <SkillGigsAvatar />
        <div className={styles.waContact}>
          <div className={styles.waContactName}>SkillGigs</div>
          <div className={styles.waContactSub}>tap here for contact info</div>
        </div>
        <div className={styles.waIcons}>
          <svg viewBox="0 0 24 24" fill="#007AFF" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4z" />
          </svg>
          <svg viewBox="0 0 24 24" fill="#007AFF" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.58a1 1 0 0 1-.25 1.01l-2.2 2.2z" />
          </svg>
        </div>
      </div>

      {/* Chat Body */}
      <div className={styles.chatBody}>
        <div className={styles.dateChip}>12 December 2025</div>
        <div className={styles.bubble}>
          <p style={{ whiteSpace: 'pre-wrap' }}>{intro}</p>
          <p>
            <span className={styles.bold}>Message from the Hiring Team</span>
            <br />
            {message || 'Employer Custom Message'}
          </p>
          <p>
            <span className={styles.bold}>Job Details:</span>
            <br />
            &ldquo;{jobDetailsString || 'Job Details'}&rdquo;
          </p>
          <p>
            👉 <span className={styles.link}>Link</span>
          </p>
          <p>
            📱Never Miss a Job Opportunity. Download Now on{' '}
            <span className={styles.link}>Android Link</span> | <span className={styles.link}>IOS Link</span>
          </p>
          <span className={styles.ts}>11:40 pm</span>
        </div>
      </div>

      {/* Input Bar */}
      <div className={styles.inputBar}>
        <span className={styles.inpPlus}>+</span>
        <div className={styles.inpField} />
        <div className={styles.inpIcons}>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#007AFF" strokeWidth="1.5" fill="none" />
            <circle cx="9" cy="10" r="1.3" fill="#007AFF" />
            <circle cx="15" cy="10" r="1.3" fill="#007AFF" />
            <path d="M8.5 15.5c.9 1.2 2.1 1.9 3.5 1.9s2.6-.7 3.5-1.9" stroke="#007AFF" strokeWidth="1.3" fill="none" strokeLinecap="round" />
          </svg>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#007AFF">
            <path d="M9 3L7.17 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3.17L15 3H9zm3 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
          </svg>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#007AFF">
            <path d="M12 1a4 4 0 0 1 4 4v6a4 4 0 0 1-8 0V5a4 4 0 0 1 4-4zm0 16a6 6 0 0 0 6-6h2a8 8 0 0 1-7 7.93V22h-2v-3.07A8 8 0 0 1 4 11h2a6 6 0 0 0 6 6z" />
          </svg>
        </div>
      </div>

      {/* Home Bar */}
      <div className={styles.homeBar}>
        <span />
      </div>
    </div>
  )
}

export default ReminderWhatsAppPreviewTemplate
